export const SHARED_STRATEGY = 'loaded-first';
